import ContainerTemplate from './ContainerTemplate';

export default ContainerTemplate;